import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_1174_564)">
      <path
        d="M8 2.33301C8.55215 2.33305 8.99984 2.78089 9 3.33301V10.2529L9.95996 9.29297C10.3505 8.90274 10.9836 8.90254 11.374 9.29297C11.7642 9.68342 11.7642 10.3166 11.374 10.707L8.70703 13.374L8.63086 13.4424C8.55834 13.5015 8.47922 13.5482 8.39648 13.584C8.39354 13.5853 8.39065 13.5866 8.3877 13.5879C8.38368 13.5896 8.38001 13.5921 8.37598 13.5938C8.3458 13.606 8.31519 13.6168 8.28418 13.626C8.26072 13.6329 8.23671 13.6374 8.21289 13.6426C8.20672 13.6439 8.20055 13.6453 8.19434 13.6465C8.06439 13.6721 7.93064 13.6728 7.80078 13.6465C7.79652 13.6456 7.79233 13.6445 7.78809 13.6436C7.73211 13.6315 7.67668 13.6155 7.62305 13.5938C7.53295 13.5572 7.44755 13.5063 7.36914 13.4424L7.29297 13.374L4.62598 10.707C4.23545 10.3165 4.23545 9.68349 4.62598 9.29297C5.01651 8.90251 5.64954 8.90247 6.04004 9.29297L7 10.2529V3.33301C7.00016 2.78086 7.44782 2.33301 8 2.33301Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1174_564">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </React.Fragment>,
  'SortDescending'
)
